export const Conventions = {
    EventNames: {
        CLICK: 'click',
        NAVIGATION: 'navigation',
        SESSION_START: 'session_start',
        VIEW_CHANGED: 'view_changed',
    },
};
//# sourceMappingURL=semantic.js.map